import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@babackapp/ui/components/dialog";
import { useCallback } from "react";
import useTranslation from "@babackapp/translations/use-translation";
import {
  UpdateOneWorkflowDto,
  WorkflowDto,
} from "@babackapp/private-api-client/types";
import EditWorkflowForm from "./edit-workflow-form";

export const EditWorkflowDialog = ({
  isOpen,
  selectedWorkflow,
  onClose,
  onSubmit,
}: {
  isOpen: boolean;
  selectedWorkflow: WorkflowDto;
  onClose: () => void;
  onSubmit: (params: {
    body: UpdateOneWorkflowDto;
    workflowId: string;
  }) => Promise<WorkflowDto> | undefined;
}) => {
  const t = useTranslation();

  const handleSubmit = useCallback(
    (data: UpdateOneWorkflowDto) => {
      if (!selectedWorkflow) return;
      onClose();
      return onSubmit({ body: data, workflowId: selectedWorkflow.id });
    },
    [onSubmit, selectedWorkflow],
  );

  return (
    <>
      {selectedWorkflow && (
        <Dialog open={isOpen} onOpenChange={onClose}>
          <DialogContent className="pt-10">
            <DialogHeader>
              <DialogTitle>{t("workflow.create.title")}</DialogTitle>
              <DialogDescription>{t("workflow.create.subtitle")}</DialogDescription>
            </DialogHeader>
            <EditWorkflowForm
              closeForm={onClose}
              onSubmit={handleSubmit}
              defaultValues={selectedWorkflow}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
